import React from 'react'

export const ScienceReadingAssignmentHandler = React.lazy(
  () => import('@freckle/student/ts/units/common/components/science-reading-assignment-handler'),
)
export const ScienceWritingAssignmentHandler = React.lazy(
  () => import('@freckle/student/ts/units/common/components/science-writing-assignment-handler'),
)
export const SocialStudiesReadingAssignmentHandler = React.lazy(
  () => import('@freckle/student/ts/units/common/components/social-studies-reading-handler'),
)
export const SocialStudiesWritingAssignmentHandler = React.lazy(
  () => import('@freckle/student/ts/units/common/components/social-studies-writing-handler'),
)
